module.exports = __webpack_public_path__ + "static/media/safety.db118188.svg";